import { gql } from "@apollo/client";

export const VITALS_FRAGMENT = gql`
  fragment VisitPatientVitalFragment on VisitPatientVital {
    id
    visitId
    values {
      id
      value
      unit
      meta {
        created
      }
    }
  }

  fragment VisitPatientVitals on VisitPatientVitals {
    id
    heartRate {
      ...VisitPatientVitalFragment
    }
    temperature {
      ...VisitPatientVitalFragment
    }
    respiratoryRate {
      ...VisitPatientVitalFragment
    }
    oxygenSaturation {
      ...VisitPatientVitalFragment
    }
    bpSystolic {
      ...VisitPatientVitalFragment
    }
    bpDiastolic {
      ...VisitPatientVitalFragment
    }
  }
`;

export const INPATIENT_VITALS_QUERY = gql`
  query InpatientVisitVitals($id: ID!) {
    visitById(id: $id) {
      _id
      vitals {
        ...VisitPatientVitals
      }
    }

    catalogueInvestigationActivities(input: { elephantCodes: ["inpatient-vitals"] }) {
      _id
      id
      title
      activityType
      coding {
        loinc {
          code
          system
          display
        }
      }
      keywords
      result {
        resultSchema
      }
    }
  }
  ${VITALS_FRAGMENT}
`;
